import { render, staticRenderFns } from "./orderAdjust_p.vue?vue&type=template&id=5003da9f&scoped=true&"
import script from "./orderAdjust_p.vue?vue&type=script&lang=js&"
export * from "./orderAdjust_p.vue?vue&type=script&lang=js&"
import style0 from "./orderAdjust_p.vue?vue&type=style&index=0&id=5003da9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003da9f",
  null
  
)

export default component.exports